<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { findTab } from '../helpers/reportsHome';

// Duas abas medem "a IA" com fontes diferentes: o Robo conta eventos de
// atendimento automatico da caixa (reporting_events), o Painel da IA conta as
// mensagens que a IA escreveu. Sem dizer isso, quem compara as duas ve numeros
// diferentes e perde a confianca nos relatorios. A nota diz o que ESTA aba
// conta e leva para a outra, quando a pessoa pode abri-la.

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  linkLabel: {
    type: String,
    required: true,
  },
  // Aba de destino, pelos ids da casa (reportsHome.js): a permissao e a flag
  // saem de la, sem repetir a regra aqui.
  areaId: {
    type: String,
    required: true,
  },
  tabId: {
    type: String,
    required: true,
  },
});

const route = useRoute();
const { shouldShow } = usePolicy();

const target = computed(() => findTab(props.areaId, props.tabId));

const canOpen = computed(
  () =>
    !!target.value &&
    shouldShow(target.value.featureFlag, target.value.permissions)
);

// O periodo viaja na query, como na troca de aba da casa.
const targetRoute = computed(() => ({
  name: target.value?.routeName,
  params: { accountId: route.params.accountId },
  query: { ...route.query },
}));
</script>

<template>
  <p
    class="flex flex-wrap items-center gap-x-1.5 gap-y-1 m-0 text-sm text-n-slate-11"
    data-testid="report-source-note"
  >
    <span class="i-ph-info size-4 shrink-0" aria-hidden="true" />
    <span>{{ text }}</span>
    <router-link
      v-if="canOpen"
      :to="targetRoute"
      class="inline-flex min-h-11 items-center rounded-md font-medium text-n-brand hover:underline outline-none focus-visible:ring-2 focus-visible:ring-n-brand"
      data-testid="report-source-note-link"
    >
      {{ linkLabel }}
    </router-link>
  </p>
</template>
